import { useEffect } from 'react';
import { StyledManageCookiesContainer } from './ManageCookies.styles';
import enviro from 'enviro';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageCookies = () => {
  const isCookieBannerOnPage = document.getElementsByClassName('cookie-banner-top-static').length > 0;
  const isQA = enviro.isQa();
  const theme = useTheme();
  if (!isCookieBannerOnPage && isQA) {
    console.warn('Cookie banner script is not loaded on this page, the ManageCookies component will not render');
  }
  useEffect(() => {
    const checkForCookieSettings = () => {
      try {
        var _hsg;
        const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');

        // Check if settings link is already visible
        const visibleSettingsLink = document.querySelector('.hs-footer-cookie-settings:not([hidden])');
        if (hiddenFooterCookieSettings && (_hsg = window._hsg) !== null && _hsg !== void 0 && (_hsg = _hsg.compliance) !== null && _hsg !== void 0 && _hsg.addSettingsLink && !visibleSettingsLink // Only add if not already visible
        ) {
          window._hsg.compliance.addSettingsLink();
        }
      } catch (error) {
        console.log('Error loading Manage Cookies link');
      }
    };

    // Run on mount
    checkForCookieSettings();

    // Add resize listener
    window.addEventListener('resize', checkForCookieSettings);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('resize', checkForCookieSettings);
    };
  }, []);
  return /*#__PURE__*/_jsx(StyledManageCookiesContainer, {
    children: /*#__PURE__*/_jsx("div", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: isCanvasTheme(theme) ? /*#__PURE__*/_jsx(Link, {
        href: "#"
      }) : /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        href: "#",
        padding: "0"
      })
    })
  });
};